import { Component, inject } from '@angular/core';
import { ContactsLinkDialogComponent } from '../contacts-link-dialog/contacts-link-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UserDataService } from 'src/app/services/userData.service';
import { SendInvitationLinkModalComponent } from "../send-invitation-link-modal/send-invitation-link-modal.component";
import { TranslateService } from '@ngx-translate/core';
import { AddContactDialogComponent } from '../add-new-contact/add-new-contact.component';

import { ApiService } from "../../services/communications/api.service";
import { SnackBarService } from '../../services/snackbar.service';
import { ModalComponent } from '../modal/modal.component';


@Component({
  selector: 'app-invitations',
  templateUrl: './invitations.component.html',
  styleUrls: ['./invitations.component.scss'],
  imports: [MatButtonModule, TranslateModule, MatTooltipModule]
})
export class InvitationsComponent {
  readonly dialog = inject(MatDialog);
  showSignIn: boolean = false;

  constructor(private userDataService: UserDataService, private snackBarService: SnackBarService, private translate: TranslateService, private apiService: ApiService) {  }

  openContactLinkInvitationDialog() {
    const screenWidth = window.innerWidth;
    const dialogWidth = screenWidth < 900 ? '90vw' : '600px';

    const dialogRef = this.dialog.open(ContactsLinkDialogComponent, {
      width: dialogWidth,
      data: { addButtons: false, assetId: this.userDataService.AssetId, expertId: this.userDataService.Id },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == 'addContact') this.openAddContactFormDialog('', '', '');
    });
  }

  openSendLinkInvitationDialog() {  
    const dialogRef = this.dialog.open(SendInvitationLinkModalComponent, {
      width: '600px',
      maxWidth: '90vw',
      autoFocus: false,
      data: {
        initialMode: 'sms',
        assetId: this.userDataService.AssetId,
        expertId: this.userDataService.Id
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Resultado del diálogo:', result);

      if (result) {
        if (result.success) {
          if (result.type == 'sendInvitation') {
            this.checkIfContactExists(result.email, result.phonePrefix, result.phoneNumber);
            this.snackBarService.openSuccess(this.translate.instant('LINK_DIALOG.SEND_SUCCESS'));
          }
          else if (result.action === 'link_copied') {
            this.snackBarService.openSuccess(this.translate.instant('LINK_DIALOG.LINK_COPIED'));
          }
        } else {
          this.snackBarService.openError(this.translate.instant('LINK_DIALOG.SEND_ERROR'));
        }
      }
      
    });
  }

  checkIfContactExists(email: String | undefined, phonePrefix: String | undefined, phoneNumber: String | undefined) {
    this.apiService.checkIfContactExists(email, phonePrefix, phoneNumber).subscribe(existsContact => {
      if (!existsContact) {
        this.askToAddContact(phonePrefix, phoneNumber, email);
      }
    })
  }

  private askToAddContact(phonePrefix: String | undefined, phoneNumber: String | undefined, email: String | undefined): void {
    const dialogRef = this.dialog.open(ModalComponent, {
      autoFocus: true,
      data: {
        title: 'ASK_ADD_CONTACT_DIALOG.TITLE',
        message: 'ASK_ADD_CONTACT_DIALOG.TEXT',
        addButtons: true
      }
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result == true) {
        this.openAddContactFormDialog(phonePrefix, phoneNumber, email);
      }
    });
  }

  private openAddContactFormDialog(phonePrefix: String | undefined, phoneNumber: String | undefined, email: String | undefined): void {
   const dialogRef = this.dialog.open(AddContactDialogComponent, {
      width: '50%',
      data: {
        email: email,
        phoneNumber: phoneNumber,
        phonePrefix: phonePrefix
      }
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.snackBarService.openSuccess(this.translate.instant('ADD_CONTACT_DIALOG.CONTACT_ADDED_SUCCESSFULLY'));
      }
    });
  }
}
